export enum enumCallStatus {
    csStatus_NotAttempted = -1,                        //used when the App does NOT attempt the API call
    csStatus_OK = 0,
    csStatus_Invalid = 1,
    csStatus_Error = 2,
    csStatus_ResponseError = 3,
    csStatus_Timeout = 4,
    csStatus_AlternativeOpen = 5,
    csStatus_NotOpen = 6,
    csStatus_DoesNotExist = 7,
    csStatus_DateRangeViolation = 8,
    csStatus_DataInUse = 9,
    csStatus_UniquenessViolation = 10,
    csStatus_VersionMismatch = 11,
    csStatus_Failure = 12,
}

export class CallStatus {
    public code: enumCallStatus;
}